import "./webinar.scss";

const getScroll = () => {
  const bodyScroll = document.body.scrollTop;
  const documentScroll = document.documentElement.scrollTop;
  if (bodyScroll === 0 && documentScroll !== 0) {
    return documentScroll;
  }

  if (documentScroll === 0 && bodyScroll !== 0) {
    return bodyScroll;
  }

  return 0;
};

function isScrolledIntoView(el: HTMLElement) {
  var rect = el.getBoundingClientRect();
  var elemBottom = rect.bottom;
  return elemBottom <= window.innerHeight;
}

document.addEventListener("DOMContentLoaded", () => {
  const stickyHeader = document.getElementById("sticky-header");
  const stickyRegisterButton = document.getElementById("sticky-register");
  const registerNowTitle = document.getElementById("register-now-title");
  const mainPart = document.getElementById("main-part");
  if (!stickyHeader || !mainPart) {
    return;
  }

  const stickyBreakpoint = mainPart.offsetTop;
  const applyStickyClassIfNeeded = () => {
    const scroll = getScroll();

    if (scroll >= stickyBreakpoint && stickyHeader.className !== "visible") {
      stickyHeader.className = "visible";
    } else if (scroll < stickyBreakpoint && stickyHeader.className === "visible") {
      stickyHeader.className = "";
    }
  };

  const toggleRegisterButtonIfNeeded = () => {
    if (!stickyRegisterButton || !registerNowTitle) {
      return;
    }
    const shouldHide = isScrolledIntoView(registerNowTitle);
    if (shouldHide) {
      stickyRegisterButton.className = "hidden";
    } else {
      stickyRegisterButton.className = "";
    }
  };

  document.addEventListener("scroll", () => {
    applyStickyClassIfNeeded();
    toggleRegisterButtonIfNeeded();
  });
  applyStickyClassIfNeeded();
  toggleRegisterButtonIfNeeded();

  const form = document.getElementById("form") as HTMLFormElement;
  const submitButton = document.getElementById("id_submit") as HTMLInputElement;
  if (!form || !submitButton) {
    return;
  }
  form.addEventListener("submit", function (ev) {
    submitButton.setAttribute("disabled", "disabled");
    submitButton.value = "Please wait...";
  });
});
